import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IWorkDebtorsQParams } from '@interfaces/IQParams';
import { IWorkDebtors, IWorkDebtorsData } from '@interfaces/IWorkDebtors';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WorkDebtorsService {
  constructor(private _http: HttpClient) {}

  get(qParams: IWorkDebtorsQParams): Observable<[]> {
    const url = `${environment.baseUrl}api/v1/homeworks-debts/`;
    let params = new HttpParams();

    Object.entries(qParams).forEach(param => {
      params = params.set(param[0], param[1]);
    });

    return this._http.get<[]>(url, { params });
  }

  getByGroup(
    groupId: number,
    qParams: IWorkDebtorsQParams
  ): Observable<IWorkDebtors> {
    const url = `${environment.baseUrl}api/v1/homeworks-debts/groups/${groupId}/`;
    let params = new HttpParams();

    Object.entries(qParams).forEach(param => {
      params = params.set(param[0], param[1]);
    });

    return this._http.get<IWorkDebtors>(url, { params });
  }

  post(data: IWorkDebtorsData): Observable<IWorkDebtors> {
    const url = `${environment.baseUrl}api/v1/homeworks-debts/`;
    return this._http.post<IWorkDebtors>(url, data);
  }
}
